<template>
  <div :class="classes" >
    <slot></slot>
  </div>
</template>

<script>
  import { findComponentsDownward, each } from '../assist';
  import Emitter from './../emitter';

  const prefixCls = 'am-radio-group';
  export default {
    name: 'RadioGroup',
    mixins: [ Emitter ],
    props: {
      value: {
        type: [String, Number],
        default: ''
      }
    },
    created() {
    },
    data() {
        return {
          currentValue: this.value,
          childrens: []
        }
    },
    mounted() {
      this.update()
    },
    computed: {
      classes () {
        return [
          `${prefixCls}`
        ]
      }
    },
    methods: {
      update () {
        let childrens = this.childrens = findComponentsDownward(this, 'Radio')
        if (childrens) {
          each(childrens, child => {
            child.currentValue = this.currentValue === child.label;
            child.group = true;
          })
        }
      },
      change (data) {
        this.currentValue = data.value;
        this.update();
        this.$emit('input', data.value);
        this.$emit('on-change', data.value);
        this.dispatch('ComboGroup', 'update');
      }
    },
    watch: {
      value () {
        if(this.currentValue !== this.value){
          this.currentValue = this.value;
          this.$nextTick(()=>{
            this.update();
          });
        }
      }
    },
    destroyed() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// components/Radio/RadioGroup.vue